export const handleNumericChange = (value: string, setValue: (val: string) => void) => {
  const cleanedValue = value.replace(/[^0-9]/g, "");
  if (cleanedValue.startsWith("0")) {
    setValue("");
    return;
  }
  setValue(cleanedValue);
};
